import { render, staticRenderFns } from "./item-inventory-modal.vue?vue&type=template&id=2c5ecabc&scoped=true"
import script from "./item-inventory-modal.vue?vue&type=script&lang=js"
export * from "./item-inventory-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ecabc",
  null
  
)

export default component.exports